import { useContextSwitch } from '@/app/use-context-switch';

/** Persistent band while viewing test data: the warn hue, tinted; nothing on these screens moves money. */
export function TestModeBanner() {
  const { switchTo, switching } = useContextSwitch();
  return (
    <div
      role="status"
      aria-label="Test data"
      className="relative flex h-[var(--band-h)] shrink-0 items-center justify-center gap-2.5 band text-xs"
    >
      <span className="rounded-sm bg-[var(--band-chip-bg)] px-1.5 py-px text-2xs font-semibold tracking-[0.08em] uppercase">
        Test data
      </span>
      <span className="hidden font-medium sm:inline">
        You’re viewing test data. Nothing here moves real money.
      </span>
      <button
        type="button"
        disabled={switching}
        onClick={() => void switchTo({ environment: 'live' })}
        className="rounded-sm font-medium underline underline-offset-2 hover:no-underline"
      >
        Switch to live
      </button>
    </div>
  );
}
